<template>
  <div>
    <section class="masthead" v-bind:style="{ 'background-image': 'url(/assets/' + backgroundImage + ')' }">
      <navigation v-bind:show-logo="showLogo"/>
      <div class="vignette--mask"></div>
      <div class="vignette--top"></div>
      <div class="vignette--bottom"></div>
      <div class="container content d-flex align-items-center">
        <div class="content-inner text-center ml-auto mr-auto" data-aos="fade-up">
          <h1 v-if="title"><span v-html="title"></span></h1>
          <img v-else src="../assets/logo@3x.png" width="200" alt="Img: Masthead Image">
          <p class="lead">{{ text }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Navigation from './Navigation.vue'

  export default {
    name: 'Masthead',
    props: {
      backgroundImage: {
        type: String,
        default: null
      },
      showLogo: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: null
      },
      text: {
        type: String,
        default: null
      }
    },
    components: {
      Navigation
    }
  }
</script>
